import React from 'react';
import { isMatch, useMatches } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/common/components/ui/breadcrumb';
import { Skeleton } from '@/common/components/ui/skeleton';
import { RouterLink } from '@/common/components/router-links/RouterLink.ts';

export const RouterBreadcrumbs = () => {
  const matches = useMatches();
  const matchesWithCrumbs = matches.filter((match) => isMatch(match, 'loaderData.breadcrumb'));

  return (
    <Breadcrumb>
      <BreadcrumbList className="font-medium">
        {matchesWithCrumbs.map((match, index) => {
          const isLast = index === matchesWithCrumbs.length - 1;
          const breadcrumb = match.loaderData?.breadcrumb;

          if (match.status === 'pending') {
            return (
              <BreadcrumbItem key={match.routeId}>
                <Skeleton className="h-4 w-20" />
              </BreadcrumbItem>
            );
          }

          return (
            <React.Fragment key={match.routeId}>
              <BreadcrumbItem className={index >= 2 ? 'hidden sm:flex' : undefined}>
                {isLast ? (
                  <BreadcrumbPage className="font-medium">{breadcrumb}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <RouterLink from={match.fullPath}>{breadcrumb}</RouterLink>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast && (
                <BreadcrumbSeparator className={index >= 2 ? 'hidden sm:flex' : undefined}>
                  <ChevronRight className="h-4 w-4" />
                </BreadcrumbSeparator>
              )}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
